<mat-card
  class="app-card"
  [ngClass]="type()">
  <mat-card-header>
    <mat-card-title>
      @if (isPrimary) {
        <mat-icon>{{ menuItem()?.matIcon }}</mat-icon>
      }
      {{ translationPrefix() + menuItem()?.name | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (isPrimary) {
      <p
        #titleComponent
        [matTooltip]="translationPrefix() + (menuItem()?.name | pure: camelCaseToKebabCase) + '-content' | translate"
        [matTooltipDisabled]="!isTruncated(titleComponent)">
        {{ translationPrefix() + (menuItem()?.name | pure: camelCaseToKebabCase) + '-content' | translate }}
      </p>
    }
  </mat-card-content>
  <mat-card-actions>
    <div>
      @if (showMoreInfoButton()) {
        <button
          class="info-button"
          mat-button
          (click)="openInformationDialog(menuItem())">
          <mat-icon>info_outline</mat-icon>
          {{ 'general.more-info-button' | translate }}
        </button>
      }
    </div>
    <div>
      <coin-v2-button
        type="primary"
        icon="chevron_right"
        iconPos="right"
        [text]="'general.open' | translate"
        (click)="openClicked.emit(menuItem())"></coin-v2-button>
    </div>
  </mat-card-actions>
</mat-card>
